import styled from "styled-components";

export const DividerContainer = styled.div`
  min-height: 1px;
  height: 1px;
  background-color: #D6D6D6;
`;
